
import { Assessment, AssessmentInterface } from 'app/assessment/models/assessment.model';

export interface SurveyInterface extends AssessmentInterface {
  lastCompletedPage?: number;
  isLatestSurvey?: boolean;
}

export class Survey extends Assessment implements SurveyInterface {
  public lastCompletedPage?: number;
  public isLatestSurvey?: boolean;

  constructor({
    lastCompletedPage = undefined,
    isLatestSurvey = undefined,
    }: SurveyInterface) {
    super(arguments[0]);
    this.lastCompletedPage = lastCompletedPage;
    this.isLatestSurvey = isLatestSurvey;
  }
}
